import {$http} from '@/utils/https'
import {
    HEADER_COURSES_SHOW_TOOLTIP,
    HEADER_NOTIFICATION_REMOVE,
    HEADER_NOTIFICATION_REQUEST_LOADING,
    HEADER_NOTIFICATION_SET_LIST,
    HEADER_NOTIFICATION_SHOW_TOOLTIP,
    HEADER_PROFILE_SHOW_TOOLTIP,
    HEADER_SET_NOTIFICATIONS_READED,
    HEADER_SET_NOTIFICATIONS_REMOVE_ALL,
} from '../mutation-types';

import {
    HEADER_FETCH_NOTIFICATION_COURSES,
    HEADER_READ_ALL_NOTIFICATIONS,
    HEADER_READ_NOTIFICATION,
    HEADER_REMOVE_ALL_NOTIFICATIONS,
    HEADER_REMOVE_NOTIFICATION,
} from '../action-types';


const state = {
    notificationsList: [],
    notificationRequestStatus: false,
    showTooltipCourses: false,
    showTooltipNotification: false,
    showTooltipProfile: false,
};

const getters = {
    notificationsList: state => state.notificationsList,
    showTooltipCourses: state => state.showTooltipCourses,
    showTooltipProfile: state => state.showTooltipProfile,
    showTooltipNotification: state => state.showTooltipNotification,
    notificationRequestStatus: state => state.notificationRequestStatus,
    notificationsReadedCount: state => state.notificationsList.filter((item) => !item.readAt).length
};

const actions = {
    [HEADER_FETCH_NOTIFICATION_COURSES]: async ({commit}) => {
        try {
            commit(HEADER_NOTIFICATION_REQUEST_LOADING, true);
            const response = await $http.get(`${process.env.VUE_APP_ROOT_NOTIFICATION}notifications`);
            commit(HEADER_NOTIFICATION_SET_LIST, response.data.data);
            return response;
        } catch (e) {
            throw e;
        } finally {
            commit(HEADER_NOTIFICATION_REQUEST_LOADING, false);
        }
    },
    [HEADER_REMOVE_NOTIFICATION]: async ({commit}, payload) => {
        try {
            commit(HEADER_NOTIFICATION_REQUEST_LOADING, true);
            const response = await $http.delete(`${process.env.VUE_APP_ROOT_NOTIFICATION}notifications/${payload}`);
            commit(HEADER_NOTIFICATION_REMOVE, payload);
            return response;
        } catch (e) {
            throw e;
        } finally {
            commit(HEADER_NOTIFICATION_REQUEST_LOADING, false);
        }
    },

    [HEADER_READ_NOTIFICATION]: async ({commit}, payload) => {
        try {
            commit(HEADER_NOTIFICATION_REQUEST_LOADING, true);
            const response = await $http.patch(`${process.env.VUE_APP_ROOT_NOTIFICATION}notifications/${payload}/read`);
            commit(HEADER_SET_NOTIFICATIONS_READED);
            return response;
        } catch (e) {
            throw e;
        } finally {
            commit(HEADER_NOTIFICATION_REQUEST_LOADING, false);
        }
    },

    [HEADER_READ_ALL_NOTIFICATIONS]: async ({commit}) => {
        try {
            commit(HEADER_NOTIFICATION_REQUEST_LOADING, true);

            const response = await $http.patch(`${process.env.VUE_APP_ROOT_NOTIFICATION}notifications/all/read`);
            commit(HEADER_SET_NOTIFICATIONS_READED);
            return response;
        } catch (e) {
            throw e;
        } finally {
            commit(HEADER_NOTIFICATION_REQUEST_LOADING, false);
        }
    },

    [HEADER_REMOVE_ALL_NOTIFICATIONS]: async ({commit}) => {
        try {
            commit(HEADER_NOTIFICATION_REQUEST_LOADING, true);

            const response = await $http.delete(`${process.env.VUE_APP_ROOT_NOTIFICATION}notifications/all`);
            commit(HEADER_SET_NOTIFICATIONS_REMOVE_ALL);
            return response;
        } catch (e) {
            throw e;
        } finally {
            commit(HEADER_NOTIFICATION_REQUEST_LOADING, false);
        }
    },
};

const mutations = {
    [HEADER_NOTIFICATION_SET_LIST](state, data) {
        state.notificationsList = data;
    },
    [HEADER_COURSES_SHOW_TOOLTIP](state, status) {
        state.showTooltipCourses = status;
    },
    [HEADER_NOTIFICATION_SHOW_TOOLTIP](state, status) {
        state.showTooltipNotification = status;
    },
    [HEADER_PROFILE_SHOW_TOOLTIP](state, status) {
        state.showTooltipProfile = status;
    },
    [HEADER_NOTIFICATION_REQUEST_LOADING](state, status) {
        state.notificationRequestStatus = status;
    },
    [HEADER_NOTIFICATION_REMOVE](state, index) {
        state.notificationsList = state.notificationsList.filter(item => {
            return item.notificationId !== index
        })
    },
    [HEADER_SET_NOTIFICATIONS_READED](state) {
        let newNotificationsList = [];
        state.notificationsList.map((notification, index) => {
            newNotificationsList.push(notification);
            newNotificationsList[index].isReaded = true
        })
        state.notificationsList = newNotificationsList
    },
    [HEADER_SET_NOTIFICATIONS_REMOVE_ALL](state) {
        state.notificationsList = []
    }
};
export default {
    state,
    getters,
    actions,
    mutations,
};
